import React, { useState } from 'react';
import Spacer from 'features/shared/Spacer';
import StatusBarWrapper from '../components/StatusBarWrapper';
import StudentsTable from './StudentsTable';
import { Plate, SubHeader } from 'features/shared/ui/Page';
import { subjectOptions, testRoundsOptions } from 'features/monitoring/models';
import { KnowledgeMonitoringApi } from 'api';
import LoaderComponent from 'features/shared/Loader';
import { TablePlateControls } from 'features/monitoring/components/TablePlateControls';
import { useStudentTableProps } from 'features/monitoring/students/useStudentTableProps';
import { FetchMonitoringData } from '../hooks/useFetchMonitoringData';

const reportText = (
  <>
    Вы можете скачать отчет о прошедших тестирование <br />
    учениках по школам в таблице
  </>
);

const Component = ({ tests = [], isRegion, participants }: FetchMonitoringData & { isRegion: boolean }) => {
  const [subject, setSubject] = useState(subjectOptions[0]);
  const [testRound, setTestRound] = useState(testRoundsOptions[0]);
  const tableProps = useStudentTableProps(isRegion, tests, subject.id, testRound.id, participants);
  const selectedTest = tests.find((test) => test.test_name === testRound.id && test.subject === subject.id);

  return (
    <Plate>
      <SubHeader>Количество учеников, прошедших тестирование</SubHeader>
      {!tableProps ? (
        <LoaderComponent />
      ) : (
        <>
          <Spacer size={40} />
          <TablePlateControls
            subject={subject}
            setSubject={setSubject}
            testRound={testRound}
            setTestRound={setTestRound}
            reportText={reportText}
            getReport={() => KnowledgeMonitoringApi.getParticipantsReportXlsx()}
            fileName="срезы-участие.xlsx"
            loggerPrefix="student_count"
            loggerPrefixTranslate="Количество учеников"
          />
          <Spacer size={10} />
          {selectedTest && (
            <StatusBarWrapper testStart={selectedTest.test_start} testEnd={selectedTest.test_end}>
              <StudentsTable {...tableProps} showSchools={!isRegion} />
            </StatusBarWrapper>
          )}
        </>
      )}
    </Plate>
  );
};

export default Component;
